import React from 'react';

import TasksToExecutors from './TasksToExecutors';
import RightSidebarSearchForm from '../_earnMoneyCommon/RightSidebarSearchForm';
import ColumnsContent from '../../../../../components/Hocs/ColumnsContent';
import GroupsSearchCollector from '../../../../../components/Hocs/GroupsSearchNewCollector/GroupsSearchCollector';
import groupsSearchItem from '../../../../../components/Hocs/GroupsSearchNewCollector/GroupsSearchItem';

const GroupsSearchItem = groupsSearchItem(TasksToExecutors);
const Content = ColumnsContent(
  GroupsSearchCollector(props => (
    <GroupsSearchItem
      {...props}
      groupName="tasksToExecutorsList"
      listReduceName="tasksModule.lists.tasksToExecutors"
    />
  )),
  () => (
    <RightSidebarSearchForm listReduceName="tasksModule.lists.tasksToExecutors" />
  )
);

export default props => <Content {...props} />;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/EarnMoney/TasksToExecutors/index.js